function redirect_to_login_page() {
  var login_button = $(".cw-modal .login_link");
  var bid_amount = login_button.attr('data-bid-amount-redirect');
  var auto_bid = login_button.attr('data-auto-bid') === 'true';
  if (window.location.toString().match(/login$|login\?|register$|register\?/)) {
    window.location = "/accounts/login";
  }
  else if (bid_amount) {
    var paramObj = {
      currency: Catawiki.currencyHelper.biddingCurrency.code,
      bidAmount: bid_amount,
      autoBid: auto_bid,
    };
    var baseUrl = window.location.origin + window.location.pathname;
    if (window.location.search) {
      window.location = "/accounts/login" + window.location.search + "&" + "redirect_after=" + encodeURIComponent(baseUrl + "?" + $.param(paramObj));
    } else {
      window.location = "/accounts/login" + "?" + "redirect_after=" + encodeURIComponent(baseUrl + "?" + $.param(paramObj));
    }
  }
  else if (window.location.search) {
    window.location = "/accounts/login" + window.location.search + "&redirect_after=" + encodeURIComponent(window.location);
  }
  else {
    window.location = "/accounts/login?redirect_after=" + encodeURIComponent(window.location);
  }
}

function addRedirectAfterUriOnRegisterClick() {
  var loginButton = $(".cw-modal .login_link");
  var bidAmount = loginButton.attr('data-bid-amount-redirect');
  var autoBid = loginButton.attr('data-auto-bid') === 'true';
  var paramObj = {
    currency: Catawiki.currencyHelper.biddingCurrency.code,
    bidAmount: bidAmount,
    autoBid: autoBid,
  };
  var baseUrl = window.location.origin + window.location.pathname;
  var redirectUrl = baseUrl + '?' + $.param(paramObj);

  window.history.pushState({ path: redirectUrl }, '', redirectUrl);
}

function redirect_to_registration_page() {
  if (window.location.toString().match(/login$|login\?|register$|register\?/)) {
    window.location = "/user/register";
  } else {
    var auction_group_id_param = "";
    if ($("#auction_group_id") && $("#auction_group_id").val() > 0) {
      auction_group_id_param = "&auction_group_id=" + $("#auction_group_id").val();
    }
    if (window.location.search) {
      window.location = "/user/register" + window.location.search + "&redirect_after=" + encodeURIComponent(window.location) + auction_group_id_param;
    } else {
      window.location = "/user/register?redirect_after=" + encodeURIComponent(window.location) + auction_group_id_param;
    }
  }
}

function redirect_to_address_completion_page() {
  var path;
  if (window.location.toString().match(/login$|login\?|register$|register\?/)) {
    path = "/register_user/complete_address";
  } else {
    var auction_group_id_param = "";
    if ($("#auction_group_id") && $("#auction_group_id").val() > 0) {
      auction_group_id_param = "&auction_group_id=" + $("#auction_group_id").val();
    }
    if (window.location.search) {
      path = "/register_user/complete_address" + window.location.search + "&redirect_after=" + encodeURIComponent(window.location) + auction_group_id_param;
    } else {
      path = "/register_user/complete_address?redirect_after=" + encodeURIComponent(window.location) + auction_group_id_param;
    }
  }
  window.location.href = 'https://' + window.location.host.replace(/(veiling|encheres|auction|auktion|aste|subastas)\./, 'www.') + path;
}

$(document).ready(function () {
  $(document).on('click','.login_link',function() {
    redirect_to_login_page();
    return false;
  });

  $(document).on('click','.register_link.v1',function() {
    redirect_to_registration_page();
    return false;
  });

  $(document).on('click','.register_link',function() {
    addRedirectAfterUriOnRegisterClick();
    return false;
  });

  $('.address_completion_link').click(function() {
    redirect_to_address_completion_page();
    return false;
  });
});
